<template>
    <header>
      <div class="app-header">
        <a class="app-functions app-navbar mr-auto" @click="onClickLogo" href="javascript:">
          <img height="46px" class="logo" src="/images/logo-header.png" alt="PVS Logo">
        </a>
<!--        <div class="app-functions app-global-search">-->
<!--          <app-global-search/>-->
<!--        </div>-->
        <span class="title">{{companyName}}</span>
        <a class="app-functions mobile" @click="onClickReport" title="Report" href="javascript:">
          <i class="fal fa-chart-bar"></i>
        </a>
        <a id="btn-synchronized" class="app-functions" title="Synchronized" href="javascript:">
          <i class="fal fa-sync" :class=" checkMaxPercentageIn2Phase ? '' : 'rotateSync'"></i>
          <p class="startDateSynchronized" v-if="checkValid">{{checkValid.start_date_synchronized}}</p>
        </a>
        <b-popover
          custom-class="synchronized-container-popover"
          target="btn-synchronized"
          placement="bottom"
          triggers="click focus hover"
          @shown="fetchDataCheckValid"
        >
          <div class="synchronized-container">
            <p v-if="checkMaxPercentageIn2Phase" class="status">{{ $t('reconciliation.synchronizeCompletion') }}</p>
            <p v-else class="status">{{ $t('reconciliation.theSystemIsSynchronizingInvoicesFromTheTax') }}...</p>
            <div class="title"><p>{{ $t('reconciliation.From') }} 01/01/2024 {{ $t('reconciliation.to') }} {{ currentDate }}</p></div>
            <app-progress :max="maxPercentage" :value="percentagePhase1"></app-progress>
            <div class="title"><p>{{ $t('reconciliation.From') }} 01/01/2023 {{ $t('reconciliation.to') }} 31/12/2023</p></div>
            <app-progress :max="maxPercentage" :value="percentagePhase2"></app-progress>
            <div class="information">
              <div class="content" v-if="checkValid">
                <img src="/images/invoice-icon.svg" alt="invoice-icon"><p>{{ $t('reconciliation.totalInvoicesRetrieved') }}: {{ checkValid.total_invoices_gained | formatAmount }}</p>
              </div>
              <div class="content" v-if="checkValid">
                <img src="/images/alarm-icon.svg" alt="alarm-icon">
                <p v-if="checkMaxPercentageIn2Phase">{{ $t('reconciliation.invoicesSynchronizedUpToDate') }} {{ currentDate }}</p>
                <p>{{ $t('reconciliation.estimatedCompletionWithin') }}: {{ checkValid.estimate_time_left_in_minutes }} {{ $t('constant.RULE_UNIT.MINUTE') }}</p>
              </div>
            </div>
          </div>
        </b-popover>
        <a id="btn-notification" class="app-functions" title="Notification" href="javascript:">
          <i class="fal fa-bell icon">
            <span v-if="unreadNotifications.page_info.total > 0" class="badge badge-danger">{{unreadNotifications.page_info.total}}</span>
          </i>
        </a>
        <b-popover
          :disabled="$route.name === 'notification'"
          custom-class="notification-container-popover"
          target="btn-notification"
          placement="bottom"
          triggers="click focus hover"
        >
          <app-notification />
        </b-popover>

        <a class="app-functions" title="Settings" @click="openModal('setting-modal')" href="javascript:">
          <i class="fal fa-cog"></i>
        </a>
<!--        <b-dropdown @click="openModal('setting-modal')" size="sm" offset="-110"  variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <a class="app-functions" href="javascript:"><i class="fal fa-cog"></i></a>
          </template>
        </b-dropdown>-->
<!--          <b-dropdown-item href="#" @click="onClickDirectory"> <i class="fal fa-sitemap"></i>{{$t('directory.updateDirectory')}}</b-dropdown-item>-->
<!--          <b-dropdown-item href="#" @click="openListRuleModal"><i class="fal fa-code-branch mr-1"></i>{{$t('rule.rule')}}</b-dropdown-item>
          <b-dropdown-item href="#" @click="openModal('company-profile-modal')"><i class="far fa-building"></i> {{$t('user.companyProfile')}}</b-dropdown-item>
          <b-dropdown-item v-if="currentUser.roboticsrole.role === 'ROBOTICS_ROLE_ADMIN'" href="#" @click="openModal('user-list-modal')"><i class="fal fa-users"></i>  {{$t('user.userManagement')}}</b-dropdown-item>
          <b-dropdown-item href="#" @click="openModal('tag-access-list-modal')"><i class="fal fa-tags"></i>  {{$t('user.customerManagement')}}</b-dropdown-item>
          <b-dropdown-item v-if="currentUser.roboticsrole.role === 'ROBOTICS_ROLE_ADMIN'" href="#" @click="openModal('e-invoice-account-list-modal')"><i class="far fa-file-alt"></i>{{$t('user.eAccountInvoice')}}</b-dropdown-item>
          <b-dropdown-item href="#" @click="openModal('company-license-modal')"><i class="fal fa-file-certificate"></i> {{$t('user.companyLicense')}}</b-dropdown-item>
          <b-dropdown-item href="#" @click="onChangeLanguage()">
            <i class="fal fa-language"></i>
            {{langText}}
          </b-dropdown-itemr-->
        <app-language-switcher></app-language-switcher>

        <a id="btn-profile" class="app-functions" title="profile" href="javascript:">
          <i class="fal fa-user-circle"></i>
        </a>
        <b-popover
          custom-class="profile-container-popover"
          target="btn-profile"
          placement="bottom"
          triggers="hover"
        >
          <div class="list-group">
            <a href="#" class="list-group-item list-group-item-action" @click="openModal('user-profile-modal')">
              <i class="fal fa-user-circle mr-1"></i> {{' '}} {{$t('user.userProfile')}}
            </a>
            <a href="#" class="list-group-item list-group-item-action" @click="logout()">
              <i class="fal fa-sign-out-alt mr-1"></i> {{' '}} {{$t('app.logout')}}
            </a>
          </div>
        </b-popover>
      </div>
      <div class="sub-header">
        <ul class="nav-item">
          <li @click="onClickBar" :class="{'text-primary': this.appNavbarDisplay}">
            <i class="fa fa-bars"></i>
          </li>
          <li
            @click="onClickPage('main.dashboard')"
            role="presentation"
            :class="{ 'is-active': isActiveTab('main') }"
            class="tabs-component-tab"
          >
            <p>
              <span> {{ $t('app.main') }} </span>
            </p>
          </li>
          <li @click="onClickPage('customer')" role="presentation" :class="{ 'is-active': isActiveTab('customer') }"
              class="tabs-component-tab">
            <p>
              <span> {{ $t('app.customer') }} </span>
            </p>
            <div
              v-b-tooltip.hover
              :title="`${totalInvoices.debt} ${$t('reconciliation.unpaidOutgoingInvoice')}`"
              class="notify" v-show="totalInvoices.debt > 0"
            >
              {{ totalInvoices.debt }}
            </div>
          </li>
          <li @click="onClickPage('vendor')" role="presentation" :class="{ 'is-active': isActiveTab('vendor') }"
              class="tabs-component-tab">
            <p>
              <span> {{ $t('app.partner') }} </span>
            </p>
            <div
              v-b-tooltip.hover
              :title="`${totalInvoices.receivable_debt} ${$t('reconciliation.unpaidIncomingInvoice')}`"
              class="notify"
              v-show="totalInvoices.receivable_debt > 0"
            >
              {{ totalInvoices.receivable_debt }}
            </div>
          </li>
        </ul>
        <div class="d-flex gap-15 mr-3">
          <button @click="openVATModal()" class="btn btn-sm btn-outline-primary">
            <i class="far fa-file-spreadsheet pr-2"></i>
            {{$t('vat.tax-filing-support')}}
          </button>
          <button :disabled="downloadExcelLoading" @click="onClickExportExcel()" class="btn btn-sm btn-outline-primary">
            <i v-if="downloadExcelLoading" class="fad fa-spinner-third fa-spin"></i>
            <i v-else class="far fa-file-excel pr-2"></i>
            {{ downloadExcelLoading ? $t('app.processing') :  $t('invoice.exportExcel') }}
          </button>
        </div>
      </div>
    </header>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import AppForm from '@/components/app-form/';
import AppAutoComplete from '@/components/app-autocomplete/';
import AppSearchBox from '@/components/app-search-box/';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
import AppLanguageSwitcher from '@/components/app-language-switcher/';
import AppProgress from '@/components/app-progress/';
import SynchronizedUtils from '@/utils/synchronized';
import DateTimeUtils from '@/utils/datetime';
import AccountProxy from '@/store/proxies/account-proxy';
import AppNotification from '@/components/app-notification';
import AppGlobalSearch from '@/portal-components/global-search';

export default {
  name: 'AppHeader',
  data() {
    return {
      maxPercentage: 100,
      currentDate: DateTimeUtils.formatDate(new Date(), 'DD/MM/YYYY'),
    };
  },
  created() {
    const body = document.querySelector('body');
    body.removeEventListener('click', this.onClickBody);
    body.addEventListener('click', this.onClickBody);
    this.getNotifications();
    this.getNotifications({ is_readed: false });
  },
  computed: {
    percentagePhase1() {
      if (!this.checkValid) return 0;

      const startDate = DateTimeUtils.parseDate('2024-01-01');
      if (this.checkValid.synchronized_first_time) {
        const fromDateSynchronized = DateTimeUtils.parseDate(this.checkValid.start_date_synchronized);
        if (DateTimeUtils.dateDiff(fromDateSynchronized, moment()) !== 0) {
          return this.calculatePercentage(startDate, fromDateSynchronized);
        }
        return this.maxPercentage;
      }

      const fromDate = DateTimeUtils.parseDate(this.checkValid.data_fail_synchronized_p1.from_date, 'DD/MM/YYYY');
      if (!fromDate) {
        const fromDateIssued = DateTimeUtils.parseDate(this.checkValid.issued_date_latest_invoice);
        if (DateTimeUtils.dateDiff(fromDateIssued, startDate) !== 0) {
          return this.calculatePercentage(startDate, fromDateIssued);
        }
        return 0;
      }

      return this.calculatePercentage(startDate, fromDate, new Date(), this.checkValid.data_fail_synchronized_p1.state ? 15 : 0);
    },
    percentagePhase2() {
      if (!this.checkValid) return 0;
      if (!this.checkValid.new_account) return this.maxPercentage;

      const fromDate = DateTimeUtils.parseDate(this.checkValid.data_fail_synchronized_p2.from_date, 'DD/MM/YYYY');
      if (!fromDate) return 0;

      const startDate = DateTimeUtils.parseDate('2023-01-01');
      const endDate = DateTimeUtils.parseDate('2023-12-31');

      return this.calculatePercentage(startDate, fromDate, endDate, this.checkValid.data_fail_synchronized_p2.state ? 15 : 0);
    },
    checkMaxPercentageIn2Phase() {
      return this.percentagePhase1 === this.maxPercentage && this.percentagePhase2 === this.maxPercentage;
    },
    companyName() {
      if (this.currentUser && this.currentUser.company) {
        return this.currentUser.company.full_name;
      }
      return '';
    },
    ...mapState([
      'activeTab',
      'invoiceList',
      'unreadNotifications',
      'appNavbarDisplay',
      'selectedDirectories',
      'totalInvoices',
      'checkValid',
      'downloadExcelLoading',
      'invoiceGlobalSearchParams',
    ]),
    ...mapState('auth', ['currentUser']),
  },
  methods: {
    ...mapActions([
      'setState',
      'downloadExcel',
      'getNotifications',
    ]),
    isActiveTab(tab) {
      return this.$route.name && this.$route.name.includes(tab);
    },
    calculatePercentage(startDate, fromDate, endDate = new Date(), addDays = 0) {
      if (addDays > 0) {
        fromDate = fromDate.add(addDays, 'days');
      }
      return SynchronizedUtils.conversionPercentage(startDate, fromDate, endDate);
    },
    fetchDataCheckValid() {
      new AccountProxy().checkValidTaxAccount().then((res) => {
        if (res) {
          localStorage.setItem('startDateSynchronized', res.start_date_synchronized);
          this.setState({
            checkValid: res,
            startDateSynchronized: res.start_date_synchronized,
          });
        }
      }, () => {});
    },
    onClickLogo() {
      // Chuyển về trang main dashboard khi click vào logo
      this.$router.push({ name: 'main.dashboard' }).catch(() => {});
    },
    onClickPage(page) {
      const query = {
        ...this.$route.query,
      };
      delete query.page;
      delete query.origin;
      delete query.page_size;
      delete query.search_text;
      delete query.invoice_type;
      delete query.invoice_outgoing;
      delete query.exclude_invoice_types;
      delete query.statistics;
      this.$router.push({ name: page, query }).catch(() => {});
    },
    onClickBody(event) {
      const isClickOnPopover = event.target.closest('.notification-container-popover');
      const isClickOnNotificationIcon = event.target.closest('#btn-notification');
      const isClickOnPopoverSynchronized = event.target.closest('.synchronized-container-popover');
      const isClickOnSynchronizedIcon = event.target.closest('#btn-synchronized');
      if (isClickOnPopover || isClickOnNotificationIcon || isClickOnPopoverSynchronized || isClickOnSynchronizedIcon) {
        return;
      }
      this.$root.$emit('bv::hide::popover', 'btn-notification');
      this.$root.$emit('bv::hide::popover', 'btn-synchronized');
    },
    // onChangeLanguage() {
    //   this.$i18n.locale = this.$i18n.locale === 'vi' ? 'en' : 'vi';
    //   localStorage.setItem('lang', this.$i18n.locale);
    //   window.location.reload();
    // },
    onClickNotificationItem(notificationItem) {
      if (notificationItem.type_of === 'NOTIFICATION_CREATE_TAG_ACCESS_LIST') {
        this.$bus.emit('jump-to-shared-invoice-list', { company_id: notificationItem.create_by, tag_access_list: notificationItem.ref_id });
      }

      if (notificationItem.type_of === 'NOTIFICATION_CONFIRM_PAID') {
        new InvoiceProxy().getInvoices({ id: notificationItem.ref_id }).then((res) => {
          this.$root.$emit('bv::hide::popover', 'btn-notification');
          this.$modal.show('invoice-form-modal', {
            invoiceList: res,
            currentIndex: 0,
          });
        });
      }
      this.markAsRead({ notification_id: notificationItem.id, value: true });
    },
    onClickBar() {
      this.setState({
        appNavbarDisplay: !this.appNavbarDisplay,
      });
    },
    onClickReport() {
      this.$modal.show('report-statistics-modal', { model: { selectedDirectories: this.selectedDirectories } });
    },
    onClickDirectory() {
      this.$modal.show('app-directory-modal', { model: {} });
    },
    openListRuleModal() {
      this.$modal.show('rule-list-modal', { model: {} });
    },
    openModal(modalName, params) {
      this.$modal.show(modalName, { model: params });
    },
    doSearch() {
      // console.log(searchText);
    },
    onSubmit() {},
    logout() {
      this.$store.dispatch('auth/logout');
      window.location.reload();
    },
    onClickExportExcel() {
      this.downloadExcel({
        start_date: this.invoiceGlobalSearchParams.start_date,
        end_date: this.invoiceGlobalSearchParams.end_date,
      });
    },
    openVATModal() {
      this.$modal.show('choose-tax-period-modal', {});
    },
    openCreateRuleModal() {
      const invoice = this.invoiceList.filter(i => this.selectedInvoices.has(i.id))[0];
      this.$modal.show('create-rule-modal', { model: {}, invoice });
    },
  },
  components: {
    AppGlobalSearch,
    AppProgress,
    AppSearchBox,
    AppForm,
    AppAutoComplete,
    AppLanguageSwitcher,
    AppNotification,
  },
};
</script>
<style lang="scss">
#btn-synchronized {
  position: relative;
  .startDateSynchronized {
    position: absolute;
    right: 0;
    left: 10px;
    font-size: 8px;
    color: white;
  }
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/layouts/app-header.vue